// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2669":"c132bf7d","5194":"badf541d"}[chunkId] || chunkId) + "." + {"2669":"9f346e708d8dba8a","2771":"7e99587b482c74b9","5194":"ccd915489e241a1c","5745":"2505d61b9aec510d","6486":"15b933549590b679"}[chunkId] + ".js";
};